export const environment = {
    production: false,
    apiUrl: 'https://api-staging.sciencenetworkhub.com/member',
    assetUrl: 'https://api-staging.sciencenetworkhub.com/uploads/', //Always add slash at end of the line
    appName: 'mfgm_mapp_staging',
    appKey: 'VvHJPFmzfRitTvTmXeDJ967fT8rjHfD3',
    recaptchaSiteKey: '6LfbCvMsAAAAALODSWZYWhpRLDcS5Vi5oIB5Iq6m'
};
